// The elfproef: the first eight digits count 9 down to 2, the last one counts against.
const ELFPROEF_WEIGHTS = [9, 8, 7, 6, 5, 4, 3, 2, -1];

const VISIBLE_DIGITS = 3;

export function isValidBsn(value) {
    const bsn = typeof value === 'string' ? value : '';

    if (!/^\d{9}$/.test(bsn) || /^0+$/.test(bsn)) {
        return false;
    }

    const sum = ELFPROEF_WEIGHTS.reduce((total, weight, index) => total + weight * Number(bsn[index]), 0);

    return sum % 11 === 0;
}

export function maskBsn(value) {
    return value ? '******' + String(value).slice(-VISIBLE_DIGITS) : '';
}

// Who last changed a stamkaart BSN and when. Only a marker on the candidate, not an audit trail.
export function bsnChangeMarker(userData) {
    return {
        bsnUpdatedBy: {id: userData.id, name: `${userData.firstname || ''} ${userData.lastname || ''}`.trim()},
        bsnUpdatedAt: new Date(),
    };
}
